"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _jsencrypt = require("@/utils/jsencrypt");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 获取验证码接口
var _default = exports.default = {
  name: "Login",
  data: function data() {
    return {
      codeUrl: "",
      cookiePassword: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        pid: 1
      },
      loginRules: {
        username: [{
          required: true,
          trigger: "blur",
          message: "用户名不能为空"
        }],
        password: [{
          required: true,
          trigger: "blur",
          message: "密码不能为空"
        }]
        // 二次修改  验证码的验证逻辑
        // code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
      loading: false,
      redirect: undefined,
      qrcode: null,
      code: undefined,
      secret: undefined,
      codeNum: 1,
      codeVisible: false
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created: function created() {
    // 二次修改 accessRoutes
    this.getCookie();
    // 替换测试环境
    this.loginForm.pid = process.env.VUE_APP_PID;
    console.log();
  },
  methods: {
    getCookie: function getCookie() {
      var username = _jsCookie.default.get("username");
      var password = _jsCookie.default.get("password");
      var rememberMe = _jsCookie.default.get("rememberMe");
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : (0, _jsencrypt.decrypt)(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin: function handleLogin() {
      var _this = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          if (_this.loginForm.rememberMe) {
            _jsCookie.default.set("username", _this.loginForm.username, {
              expires: 30
            });
            _jsCookie.default.set("password", (0, _jsencrypt.encrypt)(_this.loginForm.password), {
              expires: 30
            });
            _jsCookie.default.set("rememberMe", _this.loginForm.rememberMe, {
              expires: 30
            });
          } else {
            _jsCookie.default.remove("username");
            _jsCookie.default.remove("password");
            _jsCookie.default.remove("rememberMe");
          }
          _this.login();
        }
      });
    },
    login: function () {
      var _login = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var obj, _yield$this$$store$di, code, message, msg, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              obj = _objectSpread({}, this.loginForm);
              if (this.code) {
                obj.code = this.code;
                obj.secret = this.secret;
                delete obj.captcha;
              }
              if (obj.code === "") {
                delete obj.code;
              }
              _context.prev = 3;
              _context.next = 6;
              return this.$store.dispatch("Login", obj);
            case 6:
              _yield$this$$store$di = _context.sent;
              code = _yield$this$$store$di.code;
              message = _yield$this$$store$di.message;
              msg = _yield$this$$store$di.msg;
              data = _yield$this$$store$di.data;
              this.loading = false;
              if (!(code === 407)) {
                _context.next = 17;
                break;
              }
              this.qrcode = data.qr_code;
              this.secret = data.secret;
              this.codeVisible = true;
              return _context.abrupt("return");
            case 17:
              if (!(code === 402)) {
                _context.next = 26;
                break;
              }
              if (!(this.codeNum === 1)) {
                _context.next = 23;
                break;
              }
              this.code = "";
              this.codeVisible = true;
              this.codeNum = 2;
              return _context.abrupt("return");
            case 23:
              if (!(this.codeNum === 2)) {
                _context.next = 26;
                break;
              }
              this.$message.error(msg);
              return _context.abrupt("return");
            case 26:
              if (code == 200) {
                localStorage.setItem("name", this.loginForm.username);
                // localStorage.setItem("pwd", this.loginForm.password);
                this.jump();
              } else {
                this.loading = false;
                this.$message.error(message);
              }
              _context.next = 34;
              break;
            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](3);
              this.loading = false;
              this.$message.error("接口请求错误");
              throw _context.t0;
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 29]]);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }(),
    jump: function () {
      var _jump = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$store.dispatch("GetInfo", this.loginForm);
            case 3:
              this.$message({
                message: "登录成功",
                type: "success",
                duration: 500
              });
              setTimeout(function () {
                _this2.loading = false;
                var url = "";
                var routerData = _this2.$router.resolve({
                  path: url || "/"
                });
                window.open(routerData.href, "_self");
              }, 501);
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function jump() {
        return _jump.apply(this, arguments);
      }
      return jump;
    }(),
    handleClose: function handleClose() {
      this.codeNum = 1;
      this.code = "";
      this.qrcode = "";
      this.codeVisible = false;
    }
  }
};